<template>
  <div>
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> <router-link to="/productDisplay">{{$t('Project')}}</router-link> >> {{$t('VideoTechnology')}}</p>
    <p class="caption headline">{{ $t('Project')}}</p>
    <!--<p class="caption">产品展示</p>-->
    <p class="title">{{$t('VideoTechnology')}}</p>
    <div class="product-display">
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text2[0]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text2[1]')}}</p>
      <img src="../assets/img/pic/pc_pd_v2_1.png">
      <p class="imgName">{{$t('text2[2]')}}</p>
      <img src="../assets/img/pic/pc_pd_v2_2.png">
      <p class="imgName">{{$t('text2[3]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text2[4]')}}</p>

      <img src="../assets/img/pic/pc_pd_v2_3.png">
      <p class="imgName">{{$t('text2[5]')}}</p>
      <img src="../assets/img/pic/pc_pd_v2_4.png">
      <p class="imgName">{{$t('text2[6]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text2[7]')}}</p>
      <img src="../assets/img/pic/pc_pd_v2_5.png">
    </div>
  </div>
</template>

<script>
  export default {
    name: "pd_v2",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pd_v2.vue